var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-row',{attrs:{"label":_vm.$t('report.bdssf34.description')}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.asHtml(_vm.report.description))}})]),_c('report-row',{attrs:{"label":_vm.$t('report.bdssf34.sectors_declared')}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.report.sectors)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }